import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";

// Components
import AdminNavbar from "components/Navbars/AdminNavbar.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import HeaderStats from "components/Headers/HeaderStats.js";
import FooterAdmin from "components/Footers/FooterAdmin.js";

// Views
import LaporanJurnal from "views/admin/report/laporanJurnal/LaporanJurnal";
import BukuBesar from "views/admin/report/bukuBesar/BukuBesar";
import LabaRugi from "views/admin/report/labaRugi/LabaRugi";
import Neraca from "views/admin/report/neraca/Neraca";
import ArusKas from "views/admin/report/arusKas/ArusKas";

export default function Report() {
  return (
    <>
      <Sidebar />
      <div className="relative md:ml-64 bg-blueGray-100">
        <AdminNavbar />
        {/* Header */}
        <HeaderStats />
        <div className="px-4 md:px-10 mx-auto w-full h-screen -m-24">
          <Switch>
            <Route
              path="/report/LaporanJurnal"
              exact
              component={LaporanJurnal}
            />
            <Route path="/report/BukuBesar" exact component={BukuBesar} />
            <Route path="/report/LabaRugi" exact component={LabaRugi} />
            <Route path="/report/Neraca" exact component={Neraca} />
            <Route path="/report/ArusKas" exact component={ArusKas} />
            <Redirect from="/report" to="/masterData/KodeAkun" />
          </Switch>
          <FooterAdmin />
        </div>
      </div>
    </>
  );
}
